export const fieldTypes = [
    'bigIncrements',
    'bigInteger',
    'binary',
    'boolean',
    'char',
    'date',
    'dateTime',
    'decimal',
    'double',
    'enum',
    'float',
    'increments',
    'integer',
    'longText',
    'mediumInteger',
    'mediumText',
    'morphs',
    'nullableTimestamps',
    'smallInteger',
    'tinyInteger',
    'softDeletes',
    'string',
    'text',
    'time',
    'timestamp',
    'timestamps',
    'rememberToken',
];

export const relationshipTypes = [
    'hasOne',
    'hasMany',
    'belongsTo',
    'belongsToMany',
    'hasOneThrough',
    'hasManyThrough',
    'morphTo',
    'morphOne',
    'morphMany',
    'morphToMany',
    'morphedByMany'
];
export const fieldOptions = [
    'nullable',
    'unique',
    'autoIncrement',
    'after',
    'charset',
    'collation',
    'comment',
    'default',
    'first',
    'storedAs',
    'unsigned',
    'useCurrent',
    'virtualAs',
    'generatedAs',
    'always',
];